
<button class="btn btn-lg bg-white float-right"><i class="align-middle fas  fa-edit display-initial"></i> Edit Custom Prices</button>
<table class="neu-table table table-striped neu-table w-100" datatable [dtOptions]="dtOptions" data-page="2" ></table>